<template>
    <div class="g-table-wrapper">
        <div class="table-title">
            <d-tooltip placement="left" identifier="oekonomi.overdueInvoices" />
            Fakturaer hvor betalingsfristen er overskredet med {{ $store.state.config.companyMeta.settings.overdue_days }} dage
        </div>

        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="!loading"
        >
            <div slot="emptystate">
                Ingen data ...
            </div>
            <template slot="table-row" slot-scope="props">
                <div v-if="props.column.field == 'description'" class="table-column__description--long" :title="props.row.description">
                    {{ props.row.description }}
                </div>
                <div v-else-if="props.column.field == 'invoice_number'" style="text-align:left;">
                    {{ props.row.invoice_number }}
                </div>
                <div v-else-if="props.column.field == 'external_id'" class="table-column__external-id">
                    {{ props.row.external_id }}
                </div>
                <div v-else-if="props.column.field == 'due_at'">
                    {{ props.row.due_at | moment("DD. MMM YYYY") }}
                </div>
                <div v-else-if="props.column.field == 'amount'" style="text-align:left;">
                    {{ props.row.amount | currency }}
                </div>
                <div v-else-if="props.column.field == 'project.minuba_external_id'">
                    <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                        <i class="fas fa-eye"></i>
                    </a>
                </div>
                <div v-else :title="props.formattedRow[props.column.field]">
                    {{ props.formattedRow[props.column.field] }}
                </div>
            </template>
        </vue-good-table>   

        <box-loading height="350" v-else />
    </div>
</template>

<script>
import shared from './shared.js'
import * as invoiceService from '@/services/invoiceService'

export default {
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left' },
                { label: 'Ordre', field: 'project.case_number', type: 'string', width: '10%', align: 'left' },
                { label: 'Kunde', field: 'customer.name', type: 'string', width: '15%' },
                { label: 'Beløb', field: 'amount', type: 'number', width: '15%' },
                { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%' },
                { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%' }
            ],
            rows: [],
            searchOptions: {
                ...shared.searchOptions
            },
            paginationOptions: {
                ...shared.paginationOptions
            },
            sortOptions: {
                ...shared.sortOptions
                /* initialSortBy: {
                    field: 'type.name',
                    type: 'desc'
                } */
            },
            styleClass: 'vgt-table',
            params: {
                'filter[unpaid]': true,
                'filter[overdue]': true,
                'filter[type]': '1,3',
                'include': 'customer'
            }
        }
    },
    created () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'project.minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let params = {
                'filter[unpaid]': 'true',
                'filter[overdue]': true,
                'filter[type]': '1,3',
                include: 'customer,project',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            invoiceService.find(params, (response) => {
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// exceededPayments.vue?0d7280ed